import { render, staticRenderFns } from "./SubCategoryItem.vue?vue&type=template&id=0aa529eb&scoped=true&"
import script from "./SubCategoryItem.vue?vue&type=script&lang=js&"
export * from "./SubCategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa529eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa529eb')) {
      api.createRecord('0aa529eb', component.options)
    } else {
      api.reload('0aa529eb', component.options)
    }
    module.hot.accept("./SubCategoryItem.vue?vue&type=template&id=0aa529eb&scoped=true&", function () {
      api.rerender('0aa529eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/SubCategoryItem.vue"
export default component.exports